export default __webpack_public_path__ + "static/media/ISCO CLASS-2_SYLLABUS_2025-26.c9544bc7.pdf";